export default __webpack_public_path__ + "static/media/Lconcat-bg.4460cba2.png";